import { Button } from '@/components/Button';
import { faCloud, faGears, faLayerGroup, faServer, faShieldHeart } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onboardingRoles, roleDisplayNames, type OnboardingRole } from './roles';

const roleIcons = {
    devOps: faGears,
    itOps: faServer,
    msp: faCloud,
    sre: faShieldHeart,
    other: faLayerGroup
};

interface RoleStepProps {
    onSelect: (role: OnboardingRole) => void;
}

/**
 * First onboarding step, asking what the user does so that the data sources offered later can be
 * narrowed to the tooling their role tends to use.
 */
export const RoleStep: React.FC<RoleStepProps> = ({ onSelect }) => (
    <div data-testid='onboardingRoleStep'>
        <h1 className='mt-24 text-5xl font-medium'>Select your role</h1>
        <p className='mt-8 text-xl text-textSecondary'>This helps customize your experience.</p>

        <ul className='grid grid-cols-3 gap-3 mt-12'>
            {onboardingRoles.map((role) => (
                <li key={role}>
                    <Button
                        variant='choice'
                        className='flex-col justify-center w-full py-[20px] gap-2 bg-transparent ring-outlinePrimary rounded-[16px]'
                        onClick={() => onSelect(role)}
                        data-testid={`onboardingRole-${role}`}
                    >
                        <FontAwesomeIcon icon={roleIcons[role]} className='text-xl' />
                        <span className='text-xl'>{roleDisplayNames[role]}</span>
                    </Button>
                </li>
            ))}
        </ul>
    </div>
);
